module.exports = __webpack_public_path__ + "static/img/75077C_R_2_20171015_LC.1900cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/75077C_R_2_20171015_LC.png
// module id = wUFZ
// module chunks = 0